@use '@design/design-tokens/breakpoints/breakpoints' as *;

.styledDropdownMenu {
  @include respond-to('mobile') {
    width: 250px;
    min-width: 250px;
  }
}
